import {
  useBreadcrumbContext,
  useRouterContext,
} from '../../../context/PlpContext';

export const useBreadcrumbData = () => {
  const { breadcrumbs } = useBreadcrumbContext();
  const { query } = useRouterContext();

  return {
    breadcrumbs,
    query,
  };
};
